module.exports = __webpack_public_path__ + "img/patho-unknown-F.acf6641e.svg";